// KPI card: label with a b2 icon, 30 px blue tabular value and a muted sub-line; skeleton while loading.
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/cn";

interface KpiCardProps {
  icon?: LucideIcon;
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  loading?: boolean;
  tone?: "default" | "attn";
  className?: string;
}

export function KpiCard({
  icon: Icon,
  label,
  value,
  sub,
  loading = false,
  tone = "default",
  className,
}: KpiCardProps) {
  return (
    <Card className={cn("px-4.5 py-4", className)}>
      <div className="flex items-center gap-2 text-chip text-muted-foreground">
        {Icon ? <Icon aria-hidden className="size-[15px] text-b2" /> : null}
        {label}
      </div>
      {loading ? (
        <>
          <Skeleton className="mt-2 h-8 w-24" />
          <Skeleton className="mt-2 h-3.5 w-40" />
        </>
      ) : (
        <>
          <div
            className={cn(
              "mt-1.5 text-kpi font-bold tracking-kpi tabular-nums",
              tone === "attn" ? "text-brand-text" : "text-brand-blue",
            )}
          >
            {value}
          </div>
          {sub ? <div className="mt-1 text-xs text-muted-foreground">{sub}</div> : null}
        </>
      )}
    </Card>
  );
}
